import { Icon } from 'antd';
import React from 'react';
import styled from 'styled-components';

const YellowIcon = styled(Icon)`
    color: #ffb700;
`;

export const YellowStar = ((props) => <YellowIcon type="star" theme="filled" {...props} />) as typeof Icon;
